function FacebookFooterIcon({ size = 37.5 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="37.5" height="37.5" rx="18.75" fill="white" />
            <path d="M30.4688 18.75C30.4688 12.2779 25.2221 7.03125 18.75 7.03125C12.2779 7.03125 7.03125 12.2779 7.03125 18.75C7.03125 24.5991 11.3166 29.4473 16.9189 30.3264V22.1375H13.9435V18.75H16.9189V16.1682C16.9189 13.2312 18.6685 11.6089 21.3453 11.6089C22.627 11.6089 23.9685 11.8378 23.9685 11.8378V14.7217H22.4908C21.0352 14.7217 20.5811 15.6251 20.5811 16.5527V18.75H23.8312L23.3116 22.1375H20.5811V30.3264C26.1834 29.4473 30.4688 24.5991 30.4688 18.75Z" fill="black" />
        </svg>
    )
}
export default FacebookFooterIcon
